import { DashboardAPI } from "utils/api";

export const CHBA_RENO_COMM_ID = "CHBA_TNZ_RENO_PILOT_ADMIN";

/**
 * DashboardAPI returns the axios response on success, or the raw axios error object on failure (see utils/api request).
 */
export const normalizeCommunityPostResponse = (res) => {
    if (!res) {
        return { ok: false, status: 0, message: "No response from server.", data: null };
    }
    if (res.response?.status != null || res.isAxiosError) {
        const status = res.response?.status ?? 0;
        const body = res.response?.data;
        const message =
            (typeof body?.message === "string" && body.message) ||
            (typeof body?.error === "string" && body.error) ||
            res.message ||
            "Request failed.";
        return { ok: false, status, message, data: body ?? null };
    }
    const status = res.status ?? 0;
    const data = res.data;
    /** Backend may return 204 when there is nothing to enqueue; callers should surface this to the user. */
    if (status === 204) {
        return {
            ok: false,
            status: 204,
            message:
                (typeof data?.message === "string" && data.message) ||
                (typeof data?.error === "string" && data.error) ||
                "No combinations to run.",
            data,
        };
    }
    if (status >= 200 && status < 300) {
        return { ok: true, status, message: typeof data?.message === "string" ? data.message : "", data };
    }
    const message =
        (typeof data?.message === "string" && data.message) || (typeof data?.error === "string" && data.error) || `HTTP ${status}`;
    return { ok: false, status, message, data };
};

//Updates the entier community
export const populateChbaCommunity = async (data) => {
    const { modelId, uid } = data;
    return DashboardAPI({
        method: "POST",
        url: "/populateChbaCommunity",
        data: {
            modelId,
            uid,
        },
    }).catch((err) => {
        console.log(err.message);
    });
};

//Updates the community with info for the current model being saved
export const updateChbaCommunityWithModel = async (data) => {
    const { modelId, uid } = data;
    return DashboardAPI({
        method: "POST",
        url: "/updateChbaCommunityWithModel",
        data: {
            modelId,
            uid,
        },
    }).catch((err) => {
        console.log(err.message);
        return err;
    });
};

export const startCommunityParametricRun = async (data) => {
    const res = await DashboardAPI({
        method: "POST",
        url: "/startCommunityParametricRun",
        data: {
            ...data,
        },
    });
    return normalizeCommunityPostResponse(res);
};

export const startCommunityEcmValidation = async (data) => {
    const res = await DashboardAPI({
        method: "POST",
        url: "/startCommunityEcmValidation",
        data: {
            ...data,
        },
    });
    return normalizeCommunityPostResponse(res);
};
